<template>
  <div class="jd-page">
    <b-alert
      variant="success"
      class="jd-toast"
      :show="showDismissibleAlert"
      dismissible
    >Job link copied to clipboard</b-alert>

    <div class="container jd-page__container">
      <HcBreadcrumb>
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item"><a :href="jobsListHref">Jobs</a></li>
        <li class="breadcrumb-item active" aria-current="page" v-if="job">{{ job.job_designation }}</li>
      </HcBreadcrumb>

      <div class="jd-card">
        <JobDetailHero
          :job="job"
          :loading="loading"
          :job-type="c_job_type"
          :posted-date="job ? getDate(job.date_of_posting) : ''"
        />

        <JobDetailScamAlert />

        <div class="jd-layout">
          <div class="jd-layout__main">
            <JobDetailContent :job="job" :loading="loading" />
          </div>
          <JobDetailSidebar
            v-if="job && !loading"
            :job="job"
            :job-type="c_job_type"
            :experience="job ? getJobExp(job.experience_from, job.experience_to) : ''"
            :courses="courses"
            :branches="branches"
            :posted-date="getDate(job.date_of_posting)"
            :applied="applied"
            :expired="expired"
            :q-result="q_result"
            :has-questionnaire="hasQuestionnaire"
            :error="error"
            :err-msg="err_msg"
            :get-gender="getGender"
            @apply="checkCity"
            @share="copyToClipboard"
          />
        </div>
      </div>

      <JobDetailFaq
        v-if="job && faqs.length"
        :job="job"
        :faqs="faqs"
      />

      <JobDetailSimilar
        :jobs="jobs"
        :loading="jobs_loading"
        :show="show"
        :filter-limit="filter.limit"
        @load-more="loadmore"
      />
    </div>

    <JobDetailMobileBar
      :job="job"
      :loading="loading"
      :applied="applied"
      :expired="expired"
      :q-result="q_result"
      :has-questionnaire="hasQuestionnaire"
      :error="error"
      :err-msg="err_msg"
      @apply="checkCity"
      @share="copyToClipboard"
    />

    <b-modal id="jd-apply-success" ref="apply-success" size="sm" hide-footer hide-header hide-backdrop centered body-bg-variant="primary" body-text-variant="light">
      <div class="text-center py-2">Job applied successfully</div>
    </b-modal>

    <b-modal id="jd-city-alert" ref="city_alert" size="md" hide-footer hide-header centered>
      <div class="text-center py-3">
        <p><strong>Are you sure you want to apply for this job?</strong></p>
        <p>Your location does not match the job location.</p>
      </div>
      <div class="text-right">
        <button type="button" class="btn btn-secondary mr-2" @click.prevent="hideModal('city_alert')">Back to jobs</button>
        <button type="button" class="btn btn-primary" @click="applyJob">Proceed &amp; apply</button>
      </div>
    </b-modal>

    <Modals :open="modals.open" :src="apply_job.src" :redirect_from="redirect_from" />
  </div>
</template>

<script>
const Modals = () => import(/* webpackPrefetch: true */ '@/components/Modals');
import JobDetailHero from '@/components/job/JobDetailHero.vue';
import JobDetailSidebar from '@/components/job/JobDetailSidebar.vue';
import JobDetailContent from '@/components/job/JobDetailContent.vue';
import JobDetailScamAlert from '@/components/job/JobDetailScamAlert.vue';
import JobDetailFaq from '@/components/job/JobDetailFaq.vue';
import JobDetailSimilar from '@/components/job/JobDetailSimilar.vue';
import JobDetailMobileBar from '@/components/job/JobDetailMobileBar.vue';
import HcBreadcrumb from '@/components/chrome/HcBreadcrumb.vue';
import jobDescriptionMixin from '@/mixins/jobDescriptionMixin';
import { JOBS_LIST_PATH } from '@/utils/previewRoutes';

import '@/assets/hire.css';
import '@/assets/home-page.css';
import '@/assets/job-page.css';

export default {
  name: 'JobDescriptionPage',
  components: {
    Modals,
    HcBreadcrumb,
    JobDetailHero,
    JobDetailSidebar,
    JobDetailContent,
    JobDetailScamAlert,
    JobDetailFaq,
    JobDetailSimilar,
    JobDetailMobileBar,
  },
  mixins: [jobDescriptionMixin],
  metaInfo() {
    return this.jobDetailMetaInfo(this);
  },
  data() {
    return {
      jobDetailPreview: false,
      jobDetailCanonicalPath: null,
      jobsListHref: JOBS_LIST_PATH,
    };
  },
  watch: {
    job: {
      handler(val) {
        if (val && this.$route.params.job) {
          this.jobDetailCanonicalPath = 'jobs/' + this.$route.params.job;
        }
      },
      immediate: true,
    },
  },
};
</script>
